export const initializeEditorialMediaZoom = () => {
  document
    .querySelectorAll(
      '.layout-treatment-editorial-media-collage .wp-block-image img',
    )
    .forEach((image) => {
      image.dataset.aos = 'zoom-out';
      image.dataset.aosThreshold = '0.5';
      image.dataset.aosOffset = '0';
      image.dataset.aosDuration = '1000';
    });
};
